export default __webpack_public_path__ + "static/media/banner (1).d34e9c5a.jpg";